class Faq {
  wrapper = null;
  progress = null;
  totalSlides = 0;

  constructor(el) {
    this.wrapper = $(el);

    if ( this.wrapper.length ) {
      this.init();
    }
  }

  init() {
    // active-item
    $('.faq-block__items--item').on('click', function() {
      $(this).toggleClass('active-item');
      $(this).find('.faq-block__items--item-content').slideToggle();
    })
  }

}

export default Faq;
